import React from 'react';
export function Footer() {
  return <footer className="bg-brand-black py-12 border-t border-gray-800 text-center" data-id="element-107">
      <div className="container mx-auto px-4" data-id="element-108">
        <div className="mb-8" data-id="element-109">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-green/10 text-brand-light border border-brand-green/20 font-medium text-sm mb-4" data-id="element-110">
            🌿 RESCATE INTESTINAL +55™
          </span>
          <p className="text-gray-400 max-w-md mx-auto font-[700]" data-id="element-111">
            El primer sistema de modulación intestinal para la mujer argentina
            de más de 55 años.
          </p>
          <p className="text-gray-500 text-sm mt-2 max-w-md mx-auto italic font-[700]" data-id="element-112">
            Porque tu cuerpo no está roto. Solo está esperando que le des lo que
            realmente necesita.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-8" data-id="element-113">
          <a href="mailto:soportebiomalivido@gmail.com" className="hover:text-brand-light transition-colors" data-id="element-114">
            📧 soportebiomalivido@gmail.com
          </a>
          <a href="https://www.instagram.com/biomalivido/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-light transition-colors" data-id="element-115">
            📲 @biomalivido
          </a>
          <a href="#" className="hover:text-brand-light transition-colors" data-id="element-116">
            🌐 www.biomalivido.com
          </a>
        </div>

        <div className="text-xs text-gray-600" data-id="element-117">
          <p className="mb-2" data-id="element-118">
            © BIOMA LÍVIDO™ 2026 — Todos los derechos reservados.
          </p>
          <p data-id="element-119">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}